module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-item"
  }, [_c('el-card', {
    nativeOn: {
      "click": function($event) {
        return _vm.itemClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "payload-wrapper"
  }, [_c('div', {
    staticClass: "img-wrapper"
  }, [_c('img', {
    ref: "MyImageItem",
    staticClass: "img"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('h3', [_vm._v(_vm._s(_vm.product.name))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f30c334","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardItem.vue
// module id = 1165
// module chunks = 20